import {
  Component,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  DialogComponent,
  IDialogConfig,
} from '@affinite/common';
import { EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReferFaxComponent } from '../refer-fax/refer-fax.component';

@Component({
  selector: 'app-dialog-fax',
  imports: [ReferFaxComponent],
  templateUrl: './dialog-refer.component.html',
  styleUrls: ['./dialog-refer.component.scss']
})
export class DialogReferComponent implements OnInit {
  @ViewChild('referFaxDialogTemplate') referFaxTemplate:
    | TemplateRef<any>
    | undefined;

  @Output() referDialogEvent: EventEmitter<any> = new EventEmitter<any>();

  teamMemberSearchCtrl = new UntypedFormControl(null, Validators.required);

  dialogRef!: MatDialogRef<DialogComponent, any>;

  constructor(
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}
  //Refer Fax Dialog
  openReferFaxDialog() {
    this.dialogRef = this.dialog.open(DialogComponent, {
      width: '35em',
      data: <IDialogConfig>{
        title: 'Refer Fax',
        dialogContent: this.referFaxTemplate,
        showAcceptButton1: false,
        showDeclineButton: false
      },
      autoFocus: false,
    });
  }

  faxReferred(event: string | number) {
    this.referDialogEvent.emit({event})

    this.dialogRef.close();
  }

  cancelRefer() {
    this.teamMemberSearchCtrl.reset();
    this.dialogRef.close(); 
  }
}
